import { css } from "@emotion/react";
import styled from "@emotion/styled";
import * as React from "react";
import scrollIntoView from "scroll-into-view-if-needed";

import { DesignToken, RadiusToken } from "@livechat/design-system-react-components";

import { Collapse } from "components/collapse";
import { Icon, IconsEnum } from "components/icon";
import { KeyCodeEnum } from "constants/keyCode";
import { withVar } from "themes/helpers";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isReactComponent = (component: any): boolean =>
  React.isValidElement(component) && typeof component.type === "function";

interface ICardState {
  isCardCollapsed: boolean;
}

export interface ICardProps {
  title: React.ReactNode;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderIcon?: any;
  handleCardOpen?: () => void;
  isCardCollapsed?: boolean;
  className?: string;
  id: string;
  headerRef?: React.Ref<HTMLDivElement>;
  children: React.ReactNode;
}

interface IStyledHeaderProps {
  isCardCollapsed: boolean;
  onClick(): void;
}

const StyledCardWrapper = styled.div`
  border: solid 1px
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.borderColor
    };
  margin-bottom: 12px;
  border-radius: ${withVar(RadiusToken.Radius3)};
  background: ${withVar(DesignToken.SurfacePrimaryDefault)};
  width: 100%;
  box-sizing: border-box;

  &:focus,
  &:focus-within,
  &:hover {
    outline: 0;
  }
`;

const rotatedIcon = css`
  transform: rotate(-90deg);
`;

const StyledCardHeader = styled.div<IStyledHeaderProps>`
  height: 60px;
  font-size: 16px;
  padding: 0 20px;
  cursor: pointer;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.isCardCollapsed && "border-color: transparent;"
  };
`;

const StyledCardTitle = styled.span`
  display: inline-flex;
  align-items: center;
`;

const cardBodyStyles = css`
  padding: 0 20px;
  padding-bottom: 24px;
  font-size: 15px;
`;

const RenderIconWrapper = styled.div`
  width: 42px;
  height: 32px;
  display: flex;
  justify-content: center;
  margin-right: 20px;
  fill: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
`;

const StyledIcon = styled(Icon)`
  fill: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor50
  };
  transition: transform 0.2s ease;
`;

export class Card extends React.Component<ICardProps, ICardState> {
  private cardRef: React.RefObject<HTMLDivElement> = React.createRef();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);

    this.state = {
      isCardCollapsed: true,
    };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleToggleCard = () => {
    if (this.isControlled()) {
      // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      this.props.handleCardOpen();
      return;
    }

    this.setState(prevState => ({
      isCardCollapsed: !prevState.isCardCollapsed,
    }));
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  handleKeyDown = (e: any) => {
    if (
      (e.keyCode === KeyCodeEnum.Space || e.keyCode === KeyCodeEnum.Enter) &&
      this.cardRef.current === document.activeElement
    ) {
      e.preventDefault();

      this.handleToggleCard();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isControlled = () => this.props.handleCardOpen !== undefined && this.props.isCardCollapsed !== undefined;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isCardCollapsed = () => {
    if (this.isControlled()) {
      return this.props.isCardCollapsed;
    }

    return this.state.isCardCollapsed;
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  scrollTo = () => {
    // @ts-expect-error TS(2769)
    scrollIntoView(this.cardRef.current, {
      inline: "center",
      scrollMode: "if-needed",
      behavior: "smooth",
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { headerRef } = this.props;

    return (
      <StyledCardWrapper
        ref={this.cardRef}
        tabIndex={0}
        onKeyDown={this.handleKeyDown}
        className={this.props.className}
        id={this.props.id}
      >
        <StyledCardHeader
          onClick={this.handleToggleCard}
          // @ts-expect-error TS(2322)
          isCardCollapsed={this.isCardCollapsed()}
          custom-role="button"
          aria-expanded={!this.isCardCollapsed()}
          {...(headerRef && { ref: headerRef })}
        >
          {isReactComponent(this.props.title) ? (
            this.props.title
          ) : (
            <StyledCardTitle>
              {this.props.renderIcon && <RenderIconWrapper>{this.props.renderIcon}</RenderIconWrapper>}
              <span>{this.props.title}</span>
            </StyledCardTitle>
          )}
          <StyledIcon
            css={this.isCardCollapsed() && rotatedIcon}
            name={IconsEnum.ChevronDown}
            width="12px"
            height="12px"
            inline
          />
        </StyledCardHeader>
        {/* @ts-expect-error TS(2322) */}
        <Collapse collapsed={this.isCardCollapsed()}>
          <div css={cardBodyStyles}>{this.props.children}</div>
        </Collapse>
      </StyledCardWrapper>
    );
  }
}
